import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { MbCheckoutReviewModel } from '../../../models'

export const MB_CHECKOUT_REVIEW_NOTES_NORMALIZER = new InjectionToken<Converter<any, MbCheckoutReviewModel>>('MbCheckoutReviewNotesNormalizer')
